import { useMutation } from '@tanstack/react-query'
import { authApi } from '../api/auth.api'

interface ResetPasswordParams {
    new_password: string
    reset_token: string
}

export function useResetPassword() {
    return useMutation({
        mutationFn: ({ new_password, reset_token }: ResetPasswordParams) =>
            authApi.resetPassword(new_password, reset_token),
    })
}
